import React, { useState } from 'react';
import { TextField, FormControl, MenuItem, Button, Modal } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { isEmpty } from 'lodash';
import { TRADING_LIST } from '../constant/endpoint';
import axios from 'axios';
import Swal from 'sweetalert2';

const useStyles = makeStyles({
    modalContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
    },
    formContainer: {
        background: 'white',
        padding: '20px',
        borderRadius: '4px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        flexWrap: 'wrap',
        width: 500,
    },
    formControl: {
        margin: '10px !important',
        minWidth: '200px',
    },
});

function FormComponent({ data, hideBotModal }) {
    const classes = useStyles();
    const [formData, setFormData] = useState(data);
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: Number(value),
        });
    };

    const handleClose = () => {
        hideBotModal()
    }

    const onSubmit = async (e) => {
        e.preventDefault()
        const newFormData = new FormData()
        newFormData.append('data', JSON.stringify(formData));
        let result = await axios.patch(TRADING_LIST.replace(':match_id', formData.match_id).replace(':series_id', formData.series_id), newFormData)
        if(result?.data?.status === "success"){
            Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Bot Slot Successfully Added',
                showConfirmButton: false,
                timer: 1500
            })
            hideBotModal()
        }
    }
    return (
        <Modal open={!isEmpty(data)} className={classes.modalContainer} onClose={handleClose}>
            <form className={classes.formContainer} onSubmit={onSubmit}>
                <FormControl className={classes.formControl}>
                    <TextField
                        type="number"
                        label="Join Rate"
                        value={formData?.join_rate}
                        name="join_rate"
                        style={{ width: '200px' }}
                        onChange={handleChange}
                        inputProps={{
                            min: 0.5, // Minimum value (adjust as needed)
                            max: 9.5, // Maximum value (adjust as needed)
                          }}
                    />
                </FormControl>
                <FormControl className={classes.formControl}>
                    <TextField
                        type="number"
                        label="Exit Rate"
                        value={formData?.exit_rate}
                        name="exit_rate"
                        style={{ width: '200px' }}
                        onChange={handleChange}
                        inputProps={{
                            min: 0.5, // Minimum value (adjust as needed)
                            max: 9.5, // Maximum value (adjust as needed)
                          }}
                    />
                </FormControl>
                <FormControl className={classes.formControl}>
                    <TextField
                        type="number"
                        value={formData?.number_of_slots}
                        name="number_of_slots"
                        label="number_of_slots"
                        style={{ width: '200px' }}
                        onChange={handleChange}
                        inputProps={{
                            min: 1, // Minimum value (adjust as needed)
                          }}
                    />
                </FormControl>
                <FormControl className={classes.formControl}>
                    <TextField
                        value={formData?.join_option_id}
                        name="join_option_id"
                        label="On Option"
                        style={{ width: '200px' }}
                        select
                        onChange={handleChange}
                        required
                    >
                        <MenuItem value="1">Yes</MenuItem>
                        <MenuItem value="2">No</MenuItem>
                    </TextField>
                </FormControl>
                <FormControl className={classes.formControl}>
                    <TextField
                        type="number"
                        label="Join Percentage"
                        value={formData?.join_percentage}
                        name="join_percentage"
                        style={{ width: '200px' }}
                        inputProps={{
                            min: 1, // Minimum value (adjust as needed)
                          }}
                        onChange={handleChange}
                    />
                </FormControl>
                <Button variant="contained" color="primary" type='submit' sx={{display: 'block', width: '100%'}}>
                    Submit
                </Button>
            </form>
        </Modal>
    );
}

export default FormComponent;
